import { useLicenseRolesQuery } from "./useLicenseRolesQuery";

export const usePremiumRoles = () => {
    const { data } = useLicenseRolesQuery("PREMIUM", true);

    return data?.roles?.map((role) => role.value);
};
